import { Container, Typography, Box, Card, CardContent, Avatar, Rating, Grid } from '@mui/material';

const testimonialsData = [
  {
    name: 'Gerry Litrento',
    position: 'Founder, GL Collective',
    avatar: '/assets/GerryLitrento.jpg?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    quote: 'Having worked with Recruitment Intelligence for years at BankUnited, I’ve seen firsthand how their team delivers top-tier banking talent while keeping costs down. Their new AI assistant, RiC, takes that expertise even further — instantly surfacing and scoring hundreds of high-quality candidates, automating outreach, and making recruiting faster and smarter than ever. If you\'re serious about hiring better talent for less, a 30-minute demo is a no-brainer.',
    rating: 5
  },
  {
    name: 'Cassandra Krasne',
    position: 'President, Discover HR',
    avatar: '/assets/cassandrakrasne.jpeg?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    quote: 'Working with Recruitment Intelligence … never fails to impress. Their cutting-edge technology is matched by a team that’s attentive, professional, and genuinely invested in the success of both clients and candidates. They’ve consistently delivered exceptional talent who have made a meaningful impact on our organization.',
    rating: 5
  },
  {
    name: 'Kari Hamilton',
    position: 'VP of HR, Gemaire Distributors',
    avatar: '/assets/KariHamilton.jpeg?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    quote: 'We partnered with Recruitment Intelligence’s platform to help fill a Business Development Representative role in Dallas, and the results far exceeded our expectations. Within two weeks, we had 16 qualified, pre-screened candidates ready to interview—ultimately leading to multiple hires from a single search. What impressed us most was the quality of the candidates, the cost-effectiveness of the process, and the transparency of the data. Unlike traditional recruiting models, we now own the candidate data and can continue to leverage it for future hires without additional fees. The value and ROI have been outstanding, and we look forward to working with Recruitment Intelligence again. ',
    rating: 5
  },
  {
    name: 'DiShawn Dunmore',
    position: 'VP, Human Capital, Carey International',
    avatar: '/assets/DishawnDunmore.jpeg?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    quote: 'For the past seven Super Bowls, ARC Group and their Recruitment Intelligence platform has been our go-to partner in managing one of our most demanding staffing initiatives—hiring and onboarding 200–300 professional drivers in a matter of weeks... They understand urgency, deliver top-tier candidates, and do so with a level of professionalism that’s hard to find in this space. ARC with Recruitment Intelligence has consistently delivered—and we consider them an essential extension of our team during critical moments.',
    rating: 5
  }
];

const TestimonialsPage = () => {
  return (
    <Container sx={{ py: 4 }}>
      <Box>
      <Typography 
            variant="h5" 
            component="div"
            sx={{ 
              color: 'primary.main',
              fontWeight: 600,
              fontSize: { xs: '2rem', md: '2.5rem' },
              letterSpacing: 1.5,
              mb: 1,
              p:4,
              textTransform: 'uppercase',
              textAlign: 'center',
            }}
          >
            Client Testimonials
          </Typography>
        <Typography variant="body1" paragraph sx={{ textAlign: 'center', mb: 2 }}>  
          Hear what our satisfied clients have to say about their experience with Recruitment Intelligence®.
        </Typography>
        <Grid container spacing={3} sx={{ mt: 3 }}>
          {testimonialsData.map((testimonial, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <Avatar src={testimonial.avatar} alt={testimonial.name} sx={{ width: 56, height: 56, mb: 2 }} />
                  <Typography variant="h6">{testimonial.name}</Typography>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>{testimonial.position}</Typography>
                  <Rating value={testimonial.rating} readOnly sx={{ mb: 1 }} />
                  <Typography variant="body2">"{testimonial.quote}"</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};
export default TestimonialsPage;
